/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {CSSProperties} from "react";
import {Spacing} from "@styles/styles";
import {COLORS} from "@res/colors";

type Props = {
	height?: number
	className?: string
	style?: CSSProperties
}

export class HBar
	extends React.Component<Props> {

	render() {
		return <div
			className={this.props?.className}
			style={
				{
					width: 1,
					backgroundColor: COLORS.neutral_gray_1,
					marginRight: 3 * Spacing.s,
					marginLeft: 3 * Spacing.s,
					...this.props.style,
					height: this.props.height || 24
				}}
		/>;
	}

}
